import numeral from "numeral";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultPercentField, subStringDollarFormat, subStringPercentFormat } from "helpers/row-logic-helper";

const DEFAULT_WIDTH = 138;

const getChartData = data => {
  if (!data) {
    return [];
  }

  const propertyProjections = data && data.propertyProjections ? data.propertyProjections : [];
  rows.chart.cells[0].chartData = propertyProjections;
  rows.chart.cells[0].period = data.periodTypeAssumption;
};

export const rows = {
  chart: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.CHART,
        colSpan: 2,
        getData: getChartData,
        Cell: tableSideColumnMapper,
        chartData: [],
        label: "Property Projections",
        height: "240",
        width: "575",
        keys: ["NOI Actual", "NOI Lender"],
        axisBottomLegend: "Years",
        axisLeftLegend: "",
        indexBy: "periodDate",
        enableLabel: false,
        numeralPattern: "$0,0",
        legendParams: [{
          "dataFrom": "keys",
          "anchor": "top-left",
          "direction": "column",
          "justify": true,
          "translateX": 10,
          "translateY": -50,
          "itemsSpacing": 0,
          "itemWidth": 100,
          "itemHeight": 20,
          "itemDirection": "left-to-right",
          "itemOpacity": 0.85,
          "symbolSize": 14,
          "effects": [{ "on": "hover",
            "style": { "itemOpacity": 1 } }]
        }]
      }
    ]
  },
  term: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Term (Months)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "termAssumption"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  annualNoiIncrease: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Annual NOI Increase",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT_SUBTEXT,
        map: data => defaultPercentField(data, "noiActualBumpAssumption", 100),
        decimals: 3,
        subtextMappers: [
          {
            map: data => {
              const noiActualBumpAssumption = subStringDollarFormat(data, "noiActual");

              return `Projected NOI is ${noiActualBumpAssumption}`;
            }
          }
        ],
        Cell: tableSideColumnMapper
      }
    ]
  },
  capRate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Cap Rate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT_SUBTEXT,
        map: data => defaultPercentField(data, "capRateAssumption", 100),
        decimals: 3,
        subtextMappers: [
          {
            map: data => {
              const noiActual = defaultField(data, "noiActual");
              const marketValue = defaultField(data, "marketValue");
              if (noiActual === "--" || marketValue === "--" || marketValue === 0) {
                return "Cannot calculate Cap Rate";
              }
              const capRate = numeral(noiActual / marketValue).format("0.00%");

              return `Current cap rate is ${capRate}`;
            }
          }
        ],
        Cell: tableSideColumnMapper
      }
    ]
  },
  occupancy: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Occupancy",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT_SUBTEXT,
        map: data => defaultPercentField(data, "occupancyAssumption", 100),
        decimals: 3,
        subtextMappers: [
          {
            map: data => {
              const noiActualBumpAssumption = subStringPercentFormat(data, "occupancyRaw", "0.00%");

              return `Current occupancy is ${noiActualBumpAssumption}`;
            }
          }
        ],
        Cell: tableSideColumnMapper
      }
    ]
  }

};
